// extracted by mini-css-extract-plugin
export default {"submitPopupArea":"submitPopup_submitPopupArea__AQ7yX","submit":"submitPopup_submit__7wdPh","error":"submitPopup_error__e06fY","notice":"submitPopup_notice__CeNiL"};